//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Command, type ModelWriter } from "ckeditor5";
import { ACCORDION, createAccordionSection } from "./util";

export default class InsertAccordionCommand extends Command {
  execute() {
    this.editor.model.change((writer) => {
      this.editor.model.insertObject(this._createAccordion(writer));
    });
  }

  refresh() {
    const firstPosition = this.editor.model.document.selection.getFirstPosition();
    const allowedIn = firstPosition
      ? this.editor.model.schema.findAllowedParent(firstPosition, ACCORDION)
      : null;
    this.isEnabled = !!allowedIn;
  }

  private _createAccordion(writer: ModelWriter) {
    const accordion = writer.createElement(ACCORDION);
    createAccordionSection(this.editor, writer, accordion);
    return accordion;
  }
}
